import type { ReactNode } from 'react';
import classNames from 'styles/utils/classNames';

interface Props {
  isSelected: boolean;
  onClick: () => void;
  /** Goals stack their icon over the label; sports sit on one line. */
  layout?: 'row' | 'column';
  className?: string;
  children: ReactNode;
}

/**
 * The questionnaire's selectable card — a filled grey tile that becomes a white
 * bordered card with a lift once chosen. Shared by the goal and sport pickers.
 */
export default function SelectableCard({
  isSelected,
  onClick,
  layout = 'row',
  className,
  children,
}: Props) {
  return (
    <button
      type="button"
      aria-pressed={isSelected}
      onClick={onClick}
      className={classNames(
        // The border is always present so selecting doesn't shift layout.
        'flex items-center justify-center gap-ds-xs rounded-lg border transition-colors',
        layout === 'column' ? 'flex-col' : 'flex-row',
        isSelected
          ? 'border-brand-gray-600 bg-color-bg-lightmode-primary text-color-text-lightmode-primary shadow-[0px_4px_10px_0px_rgba(0,0,0,0.16)] dark:bg-color-bg-darkmode-primary dark:text-color-text-darkmode-primary'
          : 'border-transparent bg-color-bg-lightmode-secondary text-color-text-lightmode-secondary dark:bg-color-bg-darkmode-secondary dark:text-color-text-darkmode-secondary',
        className,
      )}
    >
      {children}
    </button>
  );
}
